var clipboard, copyUpdate, filter, getRequests, infiniteScroll, lastRefresh, markPaid, payoutTemplate, refreshDelay, renderRequest, setupEvents, ui, updateRequest;

if (global.jQuery == null) {
  global.jQuery = require('jquery');
}

require('bootstrap/js/tooltip');

require('bootstrap/js/popover');

ui = require('evesrp/common-ui');

clipboard = require('evesrp/clipboard');

filter = require('evesrp/filter');

payoutTemplate = require('evesrp/templates/payout_panel');

lastRefresh = (new Date).getTime();

refreshDelay = 7000;

renderRequest = function(request) {
  var $panel, $panelList, bothPromise;
  $panelList = jQuery('#requests');
  $panel = $panelList.find("#request-" + request.id);
  bothPromise = jQuery.when(ui.setupTranslations(), ui.setupFormats());
  return bothPromise.done(function() {
    var $copyButtons, $newPanel;
    $newPanel = jQuery(payoutTemplate(request));
    if ($panel.length !== 0) {
      $copyButtons = $panel.find('.copy-btn');
      clipboard.unclip($copyButtons);
      $copyButtons.tooltip('hide');
      ($panel.find('.small-popover')).popover('hide');
      if (($panel.find('table.in')).length !== 0) {
        ($newPanel.find('table.collapse')).addClass('in');
      }
      $panel.replaceWith($newPanel);
    } else {
      $panelList.append($newPanel);
    }
    $panel = $panelList.find("#request-" + request.id);
    $copyButtons = $panel.find('.copy-btn');
    return clipboard.clip($copyButtons);
  });
};

markPaid = function(ev) {
  var $form;
  $form = (jQuery(ev.target)).closest('form');
  jQuery.ajax({
    type: 'POST',
    url: $form.attr('action'),
    data: $form.serialize(),
    success: renderRequest
  });
  return false;
};

copyUpdate = function(ev) {
  var $panel;
  if (ev.trigger != null) {
    $panel = (jQuery(ev.trigger)).closest('.panel');
  } else {
    $panel = (jQuery(this)).closest('.panel');
  }
  return updateRequest($panel.data('request-id'));
};

getRequests = function() {
  var timestamp;
  timestamp = (new Date).getTime();
  if ((timestamp - lastRefresh) <= refreshDelay) {
    return;
  }
  lastRefresh = timestamp;
  return jQuery.ajax({
    type: 'GET',
    url: window.location.pathname,
    success: function(data) {
      var i, len, ref, request, results;
      ref = data.requests;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        request = ref[i];
        results.push(renderRequest(request));
      }
      return results;
    }
  });
};

updateRequest = function(requestID) {
  return jQuery.ajax({
    type: 'GET',
    url: scriptRoot + "/request/" + requestID + "/",
    success: renderRequest
  });
};

infiniteScroll = function(ev) {
  var $document, $window;
  $window = jQuery(window);
  $document = jQuery(document);
  if ($window.scrollTop() > ($document.height() - $window.height() - 300)) {
    return getRequests();
  }
};

setupEvents = function() {
  var $requests, $window;
  clipboard.setup();
  clipboard.attachCopy(copyUpdate);
  $requests = jQuery('#requests');
  $requests.tooltip({
    trigger: 'hover focus',
    html: false,
    selector: '.copy-btn'
  });
  $requests.popover({
    trigger: 'focus',
    html: true,
    selector: '.small-popover'
  });
  (jQuery('#requests')).on('submit', markPaid);
  $window = jQuery(window);
  $window.on('popstate', getRequests);
  $window.on('evesrp:filterchange', getRequests);
  $window.on('scroll', infiniteScroll);
  return $requests.on('click', '.null-link', function(ev) {
    return ev.preventDefault();
  });
};

exports.setupEvents = setupEvents;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
